/* tslint:disable */
/* eslint-disable */
/**
 * Localization service API
 * Service for localization Origin messages
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  L10nBatchRequestDto,
  L10nTextBatchResponseDto,
  L10nTextResponseDto,
} from '../models/index';
import {
    L10nBatchRequestDtoFromJSON,
    L10nBatchRequestDtoToJSON,
    L10nTextBatchResponseDtoFromJSON,
    L10nTextBatchResponseDtoToJSON,
    L10nTextResponseDtoFromJSON,
    L10nTextResponseDtoToJSON,
} from '../models/index';

export interface GetLocalizedText1Request {
    symbolicTextId?: string;
    lang?: string;
}

export interface GetLocalizedTextBatchForUser1Request {
    l10nBatchRequestDto: L10nBatchRequestDto;
    user?: string;
    l10nId?: string;
}

export interface GetLocalizedTextForCurrentUserRequest {
    symbolicTextId?: string;
}

export interface GetLocalizedTextForUser1Request {
    symbolicTextId?: string;
    user?: string;
    l10nId?: string;
}

/**
 * 
 */
export class L10nControllerInternalApi extends runtime.BaseAPI {

    /**
     * Returns all localized messages for the specified lang
     * Get localized text by symbolicTextId and its lang
     */
    async getLocalizedText1Raw(requestParameters: GetLocalizedText1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text/.internal`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns all localized messages for the specified lang
     * Get localized text by symbolicTextId and its lang
     */
    async getLocalizedText1(requestParameters: GetLocalizedText1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextResponseDto> {
        const response = await this.getLocalizedText1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all localized messages for the specified user or org
     * Get all localized texts by symbolicTextIds
     */
    async getLocalizedTextBatchForUser1Raw(requestParameters: GetLocalizedTextBatchForUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextBatchResponseDto>> {
        if (requestParameters['l10nBatchRequestDto'] == null) {
            throw new runtime.RequiredError(
                'l10nBatchRequestDto',
                'Required parameter "l10nBatchRequestDto" was null or undefined when calling getLocalizedTextBatchForUser1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['l10nId'] != null) {
            queryParameters['l10nId'] = requestParameters['l10nId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/v1/l10n/localized-text/.internal/user/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: L10nBatchRequestDtoToJSON(requestParameters['l10nBatchRequestDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextBatchResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns all localized messages for the specified user or org
     * Get all localized texts by symbolicTextIds
     */
    async getLocalizedTextBatchForUser1(requestParameters: GetLocalizedTextBatchForUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextBatchResponseDto> {
        const response = await this.getLocalizedTextBatchForUser1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns localized message for the requester
     * Get localized text by symbolicTextId for current user
     */
    async getLocalizedTextForCurrentUserRaw(requestParameters: GetLocalizedTextForCurrentUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text/.internal/text`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns localized message for the requester
     * Get localized text by symbolicTextId for current user
     */
    async getLocalizedTextForCurrentUser(requestParameters: GetLocalizedTextForCurrentUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextResponseDto> {
        const response = await this.getLocalizedTextForCurrentUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns localized message for the specified user or org
     * Get localized text by symbolicTextId for user or org
     */
    async getLocalizedTextForUser1Raw(requestParameters: GetLocalizedTextForUser1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<L10nTextResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['symbolicTextId'] != null) {
            queryParameters['symbolic-text-id'] = requestParameters['symbolicTextId'];
        }

        if (requestParameters['user'] != null) {
            queryParameters['user'] = requestParameters['user'];
        }

        if (requestParameters['l10nId'] != null) {
            queryParameters['l10nId'] = requestParameters['l10nId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/l10n/localized-text/.internal/user`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => L10nTextResponseDtoFromJSON(jsonValue));
    }

    /**
     * Returns localized message for the specified user or org
     * Get localized text by symbolicTextId for user or org
     */
    async getLocalizedTextForUser1(requestParameters: GetLocalizedTextForUser1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<L10nTextResponseDto> {
        const response = await this.getLocalizedTextForUser1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
